/* import { Typography } from "@mui/material"; */
import { useEffect,useState } from 'react';
import { Slider, ToggleButton, ToggleButtonGroup,Typography } from '@mui/material';
import { Rectangle } from 'recharts';

import MainPageStore from 'stores/MainPageStore';

import { moneyFormat } from 'shared/utils/utils';

export const CustomTooltip = ({ active, payload, label }: any) => {
  if (active && payload && payload.length) {
    return (
      <div className="custom-tooltip">
        <div
          style={{
            width: '15px',
            height: '15px',
            marginRight: '10px',
            background: `${payload[0].fill}`,
          }}
        ></div>
        <p className="label">{`${label} : ${payload[0].value}`}</p>
      </div>
    );
  }

  return null;
};

export const CustomTooltip2 = ({ payload, label, valueName }: any) => {

  return (
    <div className="custom-tooltip">
      <div style={MainPageStore.secondBar ? {display:'flex', alignItems:'center', marginRight:'5px', borderRight:'1px solid white', paddingRight:'5px'}:{display:'flex', alignItems:'center'}}>
      <div
        style={{
          width: '15px',
          height: '15px',
          marginRight: '10px',
          background: `${payload[0]?.fill}`,
        }}
      ></div>

      <p className="label">{`${label} : ${MainPageStore.secondBar ? (payload[0] && payload[0].payload[valueName[0]]) : moneyFormat(payload[0]?.value)}`}</p>
      </div>
      {payload[1] && (
        <div style={{display:'flex', alignItems:'center'}}>
          <div
            style={{
              width: '15px',
              height: '15px',
              marginRight: '10px',
              background: `${payload[1]?.fill}`,
            }}
          ></div>
          <p className="label">{`${label} : ${MainPageStore.secondBar ? payload[0]?.payload[valueName[1]].toFixed(2) : moneyFormat(payload[1]?.value)}`}</p>
        </div>
      )}
    </div>
  );
};

export const CustomTooltip3 = ({ payload, label }: any) => {
  return (
    <div className="custom-tooltip">
      <div
        style={{
          width: '15px',
          height: '15px',
          marginRight: '10px',
          background: `${payload[0]?.fill}`,
        }}
      ></div>
      <p className="label">{`y - ${label} : ${payload[0]?.value}`}</p>
    </div>
  );
};

export const CustomShape = (props: any) => {
  return <Rectangle {...props} height={25} x={props.x + 5} y={props.y - 22} />;
};

// Иконка сортировки по убыванию
export const SortDescIcon = () => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    style={{ display: 'block', margin: 'auto' }}
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect x="2" y="4" width="20" height="3" rx="1.5" fill="white" />
    <rect x="5" y="10" width="14" height="3" rx="1.5" fill="white" />
    <rect x="8" y="16" width="8" height="3" rx="1.5" fill="white" />
  </svg>
);

// Иконка сортировки по возрастанию
export const SortAscIcon = () => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    style={{ display: 'block', margin: 'auto' }}
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect x="8" y="4" width="8" height="3" rx="1.5" fill="white" />
    <rect x="5" y="10" width="14" height="3" rx="1.5" fill="white" />
    <rect x="2" y="16" width="20" height="3" rx="1.5" fill="white" />
  </svg>
);

// Хук для управления отображением элементов pie chart
export const usePieChartDisplay = (data: any[]) => {
  const [visibleRange, setVisibleRange] = useState<[number, number]>([0, 10]);
  const [sortOrder, setSortOrder] = useState<'desc' | 'asc'>('desc');

  // Сортировка и обрезка данных
  const sortedData = [...data].sort((a, b) =>
    sortOrder === 'desc' ? b.value - a.value : a.value - b.value,
  );
  const displayedData = sortedData.slice(visibleRange[0], visibleRange[1]);

  // Обновить слайдер при изменении data
  useEffect(() => {
    if (visibleRange[1] > data.length) {
      setVisibleRange([visibleRange[0], data.length]);
    }
  }, [data, visibleRange]);

  const handleRangeChange = (_, val: number | number[]) => {
    setVisibleRange(val as [number, number]);
  };

  const toggleSortOrder = () => {
    setSortOrder(sortOrder === 'desc' ? 'asc' : 'desc');
  };

  return {
    visibleRange,
    sortOrder,
    sortedData,
    displayedData,
    handleRangeChange,
    toggleSortOrder,
  };
};

// Компонент для отображения контролов
export const PieChartControls = ({ 
  visibleRange, 
  dataLength, 
  sortOrder, 
  onRangeChange, 
  onSortToggle 
}: {
  visibleRange: [number, number];
  dataLength: number;
  sortOrder: 'desc' | 'asc';
  onRangeChange: (event: any, value: number | number[]) => void;
  onSortToggle: () => void;
}) => {
  return (
    <div style={{ display: 'flex', alignItems: 'center', marginBottom: 16, gap: 16 }}>
      <Typography>
        Диапазон элементов: {visibleRange[0] + 1} - {visibleRange[1]} (всего: {visibleRange[1] - visibleRange[0]})
      </Typography>
      <Slider
        min={0}
        max={dataLength}
        value={visibleRange}
        onChange={onRangeChange}
        step={1}
        style={{ width: 200 }}
        valueLabelDisplay="auto"
        valueLabelFormat={(value) => value + 1}
      />
      <button
        onClick={onSortToggle}
        style={{
          background: 'transparent',
          border: 'none',
          cursor: 'pointer',
          padding: 4,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          borderRadius: 8,
          transition: 'background 0.2s',
        }}
        title={sortOrder === 'desc' ? 'Сортировать по возрастанию' : 'Сортировать по убыванию'}
      >
        {sortOrder === 'desc' ? <SortDescIcon /> : <SortAscIcon />}
      </button>
    </div>
  );
};
